export default __webpack_public_path__ + "static/media/23497640-removebg-preview.c9dc84de.png";